import ChevronDown from '@assets/icons/chevron-down.svg';
import ChevronUp from '@assets/icons/chevron-up.svg';
import React, { useState } from 'react';
import { CheckboxList } from './checkbox-list';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { ListOption } from '@/components/list-item';
import { Text, TouchableOpacity, View } from 'react-native';

interface Props {
  label: string;
  onSelect: React.Dispatch<React.SetStateAction<Set<string>>>;
  options: ListOption[];
  selected: Set<string>;
}

export const CollapsableFilters: React.FC<Props> = ({
  label,
  onSelect,
  options,
  selected,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [styles, theme] = useStyles();

  return (
    <View style={styles.base}>
      <TouchableOpacity
        onPress={() => setIsExpanded((prev) => !prev)}
        style={styles.header}
      >
        <Text style={[TYPOGRAPHY.medium, FONTS.primarySemiBold]}>{label}</Text>
        {isExpanded ? (
          <ChevronUp fill={theme.colors.primary} height={5} width={10} />
        ) : (
          <ChevronDown fill={theme.colors.primary} height={5} width={10} />
        )}
      </TouchableOpacity>
      {isExpanded ? (
        <CheckboxList
          contentContainerStyle={styles.checkboxContainer}
          listItemStyle={styles.checkboxListItem}
          options={options}
          selectedValues={selected}
          setSelectedValues={onSelect}
        />
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    borderBottomColor: theme.colors.stroke,
    borderBottomWidth: 1,
  },
  checkboxContainer: {
    paddingBottom: 8,
  },
  checkboxListItem: {
    paddingHorizontal: 0,
  },
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 16,
  },
}));
